// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BulkSms_super__NE57k {
  display: flex;
}
.BulkSms_super__NE57k > :not(:last-child) {
  margin-right: 2rem;
}

.BulkSms_main__79sDO {
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: 85vh;
  border-radius: 2rem;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.BulkSms_main__alt__5Ytx4 {
  width: 40%;
}
.BulkSms_main__79sDO::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-primary-3);
  border-radius: 0 1rem 1rem 0;
}
.BulkSms_main__79sDO::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
.BulkSms_main__nav__XROBS {
  display: flex;
  justify-content: space-between;
  font-size: var(--default-font-small);
}
@media only screen and (max-width: 31.25em) {
  .BulkSms_main__nav__XROBS {
    flex-direction: column;
  }
  .BulkSms_main__nav__XROBS > :not(:last-child) {
    margin-bottom: 1rem;
  }
}
.BulkSms_main__nav__actions__9LrPC {
  display: flex;
  align-items: center;
  background-color: var(--color-grey-5);
  border-radius: 1rem;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.08);
  border: 1px solid var(--color-dark);
}
.BulkSms_main__nav__actions__9LrPC > * {
  padding: 1rem;
  cursor: pointer;
}
.BulkSms_main__nav__actions__9LrPC > *:hover {
  font-weight: 700;
  background-color: var(--color-white);
  border-radius: 1rem;
}
.BulkSms_main__nav__actions__active__h4LBw {
  font-weight: 700;
  background-color: var(--color-white);
  border-radius: 1rem;
}
.BulkSms_main__nav__compose__5cQ9J {
  display: flex;
  align-items: center;
  background-color: var(--color-primary);
  color: var(--color-white);
  font-weight: 700;
  border-radius: 1rem;
  padding: 1rem 2rem;
  cursor: pointer;
}
.BulkSms_main__nav__compose__5cQ9J:hover {
  background-color: var(--color-primary-4);
}
.BulkSms_main__nav__compose__5cQ9J > :not(:last-child) {
  margin-right: 1rem;
  font-size: 3rem;
}
.BulkSms_main__content__ovd09 {
  margin-top: 2rem;
}
.BulkSms_main__content__cover__oEkWh {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.BulkSms_main__content__cover__oEkWh > :not(:last-child) {
  margin-right: 1rem;
}
.BulkSms_main__content__line__EA\\+7W {
  border-top: 1px solid var(--color-dark);
  margin: 2rem 0;
}

.BulkSms_compose__rJQiF {
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 61%;
  height: 85vh;
  border-radius: 2rem;
  overflow-y: auto;
  box-sizing: border-box;
  padding: 2rem;
  box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);
}
.BulkSms_compose__rJQiF::-webkit-scrollbar {
  width: 1rem;
  background-color: var(--color-primary-3);
  border-radius: 0 1rem 1rem 0;
}
.BulkSms_compose__rJQiF::-webkit-scrollbar-thumb {
  background-color: var(--color-grey);
  border-radius: 1rem;
}
@media only screen and (max-width: 56.25em) {
  .BulkSms_compose__rJQiF {
    width: 100%;
  }
}
.BulkSms_compose__rJQiF > :not(:last-child) {
  margin-bottom: 2rem;
}
.BulkSms_compose__title__xdhlC {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.BulkSms_compose__container__Ut6Sd {
  border: 1px solid var(--color-primary);
  font-size: var(--default-font-small);
  padding: 1rem;
  border-radius: 1rem;
}
.BulkSms_compose__container__Ut6Sd input:focus, .BulkSms_compose__container__Ut6Sd input:focus-visible, .BulkSms_compose__container__Ut6Sd input:focus-within {
  outline: none;
}
.BulkSms_compose__container__Ut6Sd textarea {
  width: 100%;
  height: 17rem;
}
.BulkSms_compose__container__Ut6Sd textarea:focus, .BulkSms_compose__container__Ut6Sd textarea:focus-visible, .BulkSms_compose__container__Ut6Sd textarea:focus-within {
  outline: none;
}
.BulkSms_compose__btns__pMCUw {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.BulkSms_compose__btns__pMCUw > :not(:last-child) {
  margin-right: 1rem;
}
.BulkSms_compose__btns__pMCUw > * {
  margin-bottom: 1rem;
}

.BulkSms_schedule__Uxa-Z {
  display: flex;
  flex-direction: column;
  width: 38rem;
}
.BulkSms_schedule__Uxa-Z > :not(:last-child) {
  margin-bottom: 1rem;
}

.BulkSms_singleMessage__Kyhyy {
  padding: 3rem;
}

.BulkSms_beside__d-d-B {
  display: flex;
  flex-wrap: wrap;
}
.BulkSms_beside__d-d-B > :not(:last-child) {
  margin-right: 2rem;
}

.BulkSms_pageLoad__P8y9L {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/BulkSms/BulkSms.module.scss"],"names":[],"mappings":"AAEA;EACC,aAAA;AADD;AAEC;EACC,kBAAA;AAAF;;AAIA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,4CAAA;AADD;AAGC;EACC,UAAA;AADF;AAIC;EACC,WAAA;EACA,wCAAA;EACA,4BAAA;AAFF;AAKC;EACC,mCAAA;EACA,mBAAA;AAHF;AAMC;EACC,aAAA;EACA,8BAAA;EACA,oCAAA;AAJF;AAME;EALD;IAME,sBAAA;EAHD;EAKC;IACC,mBAAA;EAHF;AACF;AAQE;EACC,aAAA;EACA,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,4CAAA;EACA,mCAAA;AANH;AAQG;EACC,aAAA;EACA,eAAA;AANJ;AAQI;EACC,gBAAA;EACA,oCAAA;EACA,mBAAA;AANL;AAUG;EACC,gBAAA;EACA,oCAAA;EACA,mBAAA;AARJ;AAYE;EACC,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAVH;AAYG;EAEC,wCAAA;AAXJ;AAgBG;EACC,kBAAA;EACA,eAAA;AAdJ;AAmBC;EACC,gBAAA;AAjBF;AAkBE;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;AAhBH;AAmBG;EACC,kBAAA;AAjBJ;AAqBE;EACC,uCAAA;EACA,cAAA;AAnBH;;AAwBA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,4CAAA;AArBD;AAuBC;EACC,WAAA;EACA,wCAAA;EACA,4BAAA;AArBF;AAwBC;EACC,mCAAA;EACA,mBAAA;AAtBF;AAyBC;EAvBD;IAwBE,WAAA;EAtBA;AACF;AAwBC;EACC,mBAAA;AAtBF;AAyBC;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAvBF;AA+BC;EACC,sCAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;AA7BF;AAgCG;EACC,aAAA;AA9BJ;AAkCE;EACE,WAAA;EACA,aAAA;AAhCJ;AAkCI;EACA,aAAA;AAhCJ;AAsCC;EACC,aAAA;EACA,mBAAA;EACA,eAAA;AApCF;AAsCE;EACC,kBAAA;AApCH;AAuCE;EACC,mBAAA;AArCH;;AA2CA;EACC,aAAA;EACA,sBAAA;EACA,YAAA;AAxCD;AAyCC;EACC,mBAAA;AAvCF;;AA2CA;EACC,aAAA;AAxCD;;AA2CA;EACC,aAAA;EACA,eAAA;AAxCD;AA0CC;EACC,kBAAA;AAxCF;;AA4CA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAzCD","sourcesContent":["@import '../variables/breakpoints';\n\n.super {\n\tdisplay: flex;\n\t& > :not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n}\n\n.main {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: white;\n\twidth: 100%;\n\theight: 85vh;\n\tborder-radius: 2rem;\n\toverflow-y: auto;\n\tbox-sizing: border-box;\n\tpadding: 2rem;\t\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n\t&__alt {\n\t\twidth: 40%;\n\t}\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 1rem;\n\t}\n\n\t&__nav {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tfont-size: var(--default-font-small);\n\n\t\t@media only screen and (max-width: $bp-500) {\n\t\t\tflex-direction: column;\n\t\t\t// justify-content: flex-start;\n\t\t\t& > :not(:last-child) {\n\t\t\t\tmargin-bottom: 1rem;\n\t\t\t}\n\n\t\t}\n\n\t\t\n\t\t&__actions {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tbackground-color: var(--color-grey-5);\n\t\t\tborder-radius: 1rem;\n\t\t\tbox-shadow: 0px 6px 10px rgba(0, 0, 0, 0.08);\n\t\t\tborder: 1px solid var(--color-dark);\n\n\t\t\t& > * {\n\t\t\t\tpadding: 1rem;\n\t\t\t\tcursor: pointer;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tfont-weight: 700;\n\t\t\t\t\tbackground-color: var(--color-white);\n\t\t\t\t\tborder-radius: 1rem;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t&__active {\n\t\t\t\tfont-weight: 700;\n\t\t\t\tbackground-color: var(--color-white);\n\t\t\t\tborder-radius: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&__compose {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tbackground-color: var(--color-primary);\n\t\t\tcolor: var(--color-white);\n\t\t\tfont-weight: 700;\n\t\t\tborder-radius: 1rem;\n\t\t\tpadding: 1rem 2rem;\n\t\t\tcursor: pointer;\n\n\t\t\t&:hover {\n\t\t\t\t\n\t\t\t\tbackground-color: var(--color-primary-4);\n\t\t\t\t\n\t\t\t}\n\n\n\t\t\t& > :not(:last-child) {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t\tfont-size: 3rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t&__content {\n\t\tmargin-top: 2rem;\n\t\t&__cover {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t\talign-items: center;\n\t\t\twidth: 100%;\n\n\n\t\t\t& > :not(:last-child) {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t}\n\n\t\t&__line {\n\t\t\tborder-top: 1px solid var(--color-dark);\n\t\t\tmargin: 2rem 0;\n\t\t}\n\t}\n}\n\n.compose {\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: white;\n\twidth: 61%;\n\theight: 85vh;\n\tborder-radius: 2rem;\n\toverflow-y: auto;\n\tbox-sizing: border-box;\n\tpadding: 2rem;\t\n\tbox-shadow: 0px 6px 30px rgba(0, 0, 0, 0.08);\n\n\t&::-webkit-scrollbar {\n\t\twidth: 1rem;\n\t\tbackground-color: var(--color-primary-3);\n\t\tborder-radius: 0 1rem 1rem 0;\n\t}\n\n\t&::-webkit-scrollbar-thumb {\n\t\tbackground-color: var(--color-grey);\n\t\tborder-radius: 1rem;\n\t}\n\n\t@media only screen and (max-width: $bp-900) {\n\t\twidth: 100%;\n\t}\n\n\t& > :not(:last-child) {\n\t\tmargin-bottom: 2rem;\n\t}\n\n\t&__title {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t}\n\n\t&__selectContact {\n\t\t\n\t\t\n\t}\n\n\t&__container {\n\t\tborder: 1px solid var(--color-primary);\n\t\tfont-size: var(--default-font-small);\n\t\tpadding: 1rem;\n\t\tborder-radius: 1rem;\n\n\t\tinput {\n\t\t\t&:focus, &:focus-visible, &:focus-within {\n\t\t\t\toutline: none;\n\t\t\t}\n\t\t}\n\n\t\ttextarea {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 17rem;\n\t\t\t\t\n\t\t\t\t&:focus, &:focus-visible, &:focus-within {\n\t\t\t\toutline: none;\n\t\t\t\t\n\t\t\t}\n\t\t}\n\t}\n\n\t&__btns {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tflex-wrap: wrap;\n\n\t\t& > :not(:last-child) {\n\t\t\tmargin-right: 1rem;\n\t\t}\n\n\t\t& > * {\n\t\t\tmargin-bottom: 1rem;\n\t\t\t\n\t\t}\n\t}\n}\n\n.schedule {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 38rem;\n\t& > :not(:last-child) {\n\t\tmargin-bottom: 1rem;\n\t}\n}\n\n.singleMessage {\n\tpadding: 3rem;\n}\n\n.beside {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\t\n\t& > :not(:last-child) {\n\t\tmargin-right: 2rem;\n\t}\n}\n\n.pageLoad {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\twidth: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"super": `BulkSms_super__NE57k`,
	"main": `BulkSms_main__79sDO`,
	"main__alt": `BulkSms_main__alt__5Ytx4`,
	"main__nav": `BulkSms_main__nav__XROBS`,
	"main__nav__actions": `BulkSms_main__nav__actions__9LrPC`,
	"main__nav__actions__active": `BulkSms_main__nav__actions__active__h4LBw`,
	"main__nav__compose": `BulkSms_main__nav__compose__5cQ9J`,
	"main__content": `BulkSms_main__content__ovd09`,
	"main__content__cover": `BulkSms_main__content__cover__oEkWh`,
	"main__content__line": `BulkSms_main__content__line__EA+7W`,
	"compose": `BulkSms_compose__rJQiF`,
	"compose__title": `BulkSms_compose__title__xdhlC`,
	"compose__container": `BulkSms_compose__container__Ut6Sd`,
	"compose__btns": `BulkSms_compose__btns__pMCUw`,
	"schedule": `BulkSms_schedule__Uxa-Z`,
	"singleMessage": `BulkSms_singleMessage__Kyhyy`,
	"beside": `BulkSms_beside__d-d-B`,
	"pageLoad": `BulkSms_pageLoad__P8y9L`
};
export default ___CSS_LOADER_EXPORT___;
